import { FC } from 'react';

import { appSettings } from '@/settings/app-settings';

type SocialLoginProps = {
  saveVendorTermsToLocal?: () => void;
  portalId?: string;
};

const SocialLogin: FC<SocialLoginProps> = ({ saveVendorTermsToLocal, portalId }) => {
  const onSocialLogin = (provider: string) => {
    if (window.location.pathname != '/login' && !portalId) {
      localStorage.setItem('redirectPrevURL', window.location.pathname.substring(1) + window.location.search);
    }

    if (portalId) {
      localStorage.setItem('redirectPrevURL', `portal?id=${portalId}`);
    }

    saveVendorTermsToLocal?.();

    const redirect_uri_base =
      window.origin == 'http://localhost:3000' ? window.origin : appSettings.api.CLIENT_APP_URL;

    const requestUrl =
      `${appSettings.api.OPEN_ID_COGNITO_URL}/oauth2/authorize` +
      `?client_id=${appSettings.api.OPEN_ID_COGNITO_CLIENT_ID}` +
      `&redirect_uri=${redirect_uri_base}/${appSettings.api.OPEN_ID_COGNITO_CALLBACK_PATH}` +
      `&scope=openid email` +
      `&response_type=code` +
      `&identity_provider=${provider}`;

    window.location.href = requestUrl;
  };

  return (
    <div className="flex gap-2 flex-col font-bold">
      <button
        tabIndex={-1}
        type="button"
        className="p-1.5 flex gap-4 justify-center rounded-full border-2 border-gray-500 dark:border-gray-400"
        onClick={() => onSocialLogin('Google')}
      >
        <img className="w-[20px] h-[20px]" src="/images/connect/google-icon.svg" alt="google" />
        <span className="text-black dark:text-white">Continue with Google</span>
      </button>
      {/* <button
        tabIndex={-1}
        type="button"
        className="p-1.5 flex gap-4 justify-center rounded-full border-2 border-gray-500"
        onClick={() => onSocialLogin('SignInWithApple')}
      >
        <img className="w-[20px] h-[20px]" src="/images/connect/apple-icon.svg" alt="apple" />
        <span>Continue with Apple</span>
      </button> */}
    </div>
  );
};

export default SocialLogin;
